"use strict";
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnalytics = createAnalytics;
var analytics_client_1 = require("./src/analytics_client");
/**
 * Creates an {@link AnalyticsClient}.
 * @param initContext The initial context to create the client {@link AnalyticsClientInitContext}
 */
function createAnalytics(initContext) {
    return new analytics_client_1.AnalyticsClient(initContext);
}
